import { useQuery } from '@tanstack/react-query';
import { billingApi, type MyInvoicesResponse } from '../infrastructure/billing.api';

// Query keys for the portal billing feature. Read-only in v1 — no payment command exists (see
// .ai/BusinessDomain/billing-payment.md, "Patient Portal Visibility").
export const billingKeys = {
  all: ['portal-billing'] as const,
  invoiceList: () => ['portal-billing', 'invoices'] as const,
};

/** Read — the patient's own invoices, plus currency and outstanding balance. */
export function useMyInvoicesQuery() {
  return useQuery<MyInvoicesResponse>({
    queryKey: billingKeys.invoiceList(),
    queryFn: () => billingApi.listInvoices(),
  });
}
